export default __webpack_public_path__ + "static/media/image.rearboost-innovations.e477287f.png";